export default class EmbedPolicy {
  constructor(options){
    this.domain   = null;
    this.referrer = document.referrer;
    this.allowedDomains = null;
    this.$element = $(options.element);
    this.siteAllowed = false;
    this.playerOnly = false;
    this.jsEmbedPolicySelector = ".js-embed-policy";
  }

  init(){
    this.getReferrerDomain();
    this.getAllowedDomains();
    this.isAllowed();
    this.setPlayerOnly();

    this.hideElement();
  }

  setPlayerOnly(){
    this.playerOnly = (this.getParameterByName('player_only') === 'true');
  }

  hideElement() {
    if(this.siteAllowed && this.playerOnly){
      $(this.jsEmbedPolicySelector).addClass("hide");
    }
  }

  getReferrerDomain() {
    if (this.referrer.indexOf("://") > -1) {
      this.domain = this.referrer.split('/')[2];
    } else {
      this.domain = this.referrer.split('/')[0];
    }
    this.domain = this.domain.split(':')[0];
  }

  getAllowedDomains() {
    this.allowedDomains = window.Config.WhitelistEmbedDomains;
  }

  isAllowed() {
    var domain = this.domain;
    let isVidioDomain = new RegExp("(\w+.)*vidio.com$").test(domain);
    if(isVidioDomain) {
      return this.siteAllowed = true;
    }

    if(this.allowedDomains) {
      this.siteAllowed = this.allowedDomains.split(" ").some((allowedDomain) => {
        if(allowedDomain.match(/^\*./)) {
          var cleanUpAllowedDomain = allowedDomain.replace(/^\*\./, '');
          var regexAllowedDomain = new RegExp("(\w+.)*" + cleanUpAllowedDomain + "$");
          return regexAllowedDomain.test(domain);
        } else {
          return domain == allowedDomain;
        }
      });
    }
  }

  // ref : http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}
